export default __webpack_public_path__ + "static/media/how-it-work2-grey.149f37f2.svg";